// extracted by mini-css-extract-plugin
export var active = "_8t-7";
export var container = "_8t-0";
export var evenWidth = "_8t-4";
export var large = "_8t-5";
export var outlet = "_8t-8";
export var slide = "_8t-2";
export var small = "_8t-6";
export var tab = "_8t-3";
export var tabs = "_8t-1";